/**
 * feature-config flag names owned by styles
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const STYLES_FLAG_NAMES = {
  COMPACT_VARIABLES_LIST: 'ff-apai-2412-compact-variables-list',
  IX3_CONDITIONS: 'ff-ix3-conditions', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-ix3-conditions
  IX3_NAVBAR_DROPDOWN_TRIGGERS: 'ff-style-ix3-navbar-dropdown-triggers', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-style-ix3-navbar-dropdown-triggers
  IX3_SCROLL_SPLIT: 'ff-styl-ix3-scroll-split', // Splits the Scroll trigger into separate "Scroll scrub", "Scroll actions" and "Scroll direction" interaction types
  IX3_HOVER_MULTI_TIMELINE: 'ff-style-ix3-hover-multi-timeline',
  /**
   * The two selector-free triggers built alongside the Popover work but not
   * specific to it: Exit intent and Duration. They share one gate — neither has
   * a UI or runtime surface the other doesn't — and it is separate from
   * `BUILDING_BLOCKS_POPOVERS` so a Popover slip doesn't hold them back.
   */
  IX3_PAGE_INTENT_TRIGGERS: 'ff-styl-ix3-page-intent-triggers',
  IMPORT_FROM_LINK: 'ff-styl-571-import-from-link',
  PER_PAGE_CSS: 'ff-per-page-css',
  VARIABLE_OVERRIDES: 'ff-variable-overrides',
  ELEMENT_STYLES: 'ff-element-styles', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-element-styles
  NEW_STYLE_SELECTOR_UI: 'ff-new-style-selector-ui',
  VCC_STYLE_PANEL: 'ff-styl-2185-styles-panel-for-vibe-code-components', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-styl-2185-styles-panel-for-vibe-code-components
  WORKBENCH_RESOLVER: 'ff-styl-2206-workbench-resolver', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-styl-2206-workbench-resolver
  TYPOGRAPHY_MORE_OPTIONS_REDESIGN:
    'ff-styl-2313-typography-more-options-redesign', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-styl-2313-typography-more-options-redesign
  IX3_TIMELINE_GROUPS: 'ff-styl-ix3-timeline-groups', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-styl-ix3-timeline-groups
  // Rollout gate for the publish-time allowlist on wf:style / wf:transform action
  // property names. Off = shadow mode: everything publishes and the names the
  // allowlist would drop are reported. On = the allowlist drops them.
  // Temporary: remove the gate, and the shadow branch, once enforce is at 100%.
  IX3_ACTION_PROPERTY_ALLOWLIST: 'ff-styl-ix3-action-property-allowlist', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-styl-ix3-action-property-allowlist
  // Tween arbitrary CSS properties and CSS variables from the Interactions panel. See STYL-2356.
  IX3_CUSTOM_PROPERTIES: 'ff-styl-2356-ix3-custom-properties', // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-styl-2356-ix3-custom-properties
  // Gates renaming the base mode of a variable collection. See STYL-1335.
  RENAMABLE_BASE_MODE: 'ff-styl-1335-renamable-base-mode',
  AUTO_CLEANUP_DELETED_VARIABLES: 'ff-auto-cleanup-deleted-variables',
  // Kill switch for the engine that auto-removes orphaned IX2 class targets
  // after element deletion (DSYS-7102).
  IX2_ORPHANED_CLASS_CLEANUP: 'ff-dsys-7102-ix2-orphaned-class-cleanup',
  VARIABLE_MODE_REORDERING: 'ff-styl-2355-variable-mode-reordering',
  // Gates the IX3 interactions REST/MCP tools. Consumed server-side via
  // `IX3_INTERACTION_APIS_FEATURE_FLAG`.
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-ix3-interaction-apis
  IX3_INTERACTION_APIS: 'ff-ix3-interaction-apis',
  // Per-page CSS: resolve classes forwarded into nested component class props (DES-7783).
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-des-7783-per-page-css-forwarded-class-props
  PER_PAGE_CSS_FORWARDED_CLASS_PROPS:
    'ff-des-7783-per-page-css-forwarded-class-props',
};
